


// import React, { useState, useEffect, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import { ArrowRight, MapPin, Home as HomeIcon } from 'lucide-react';
// import aerialview from '../Assets/AERIAL VIEW -  (1).jpg';
// import aerialview2 from '../Assets/AERIAL VIEW -  (2).jpg';
// import aerialview3 from '../Assets/AERIAL VIEW -  (5).jpg';
// import aerialview4 from '../Assets/AERIAL VIEW -  (6).jpg';
// import clubhouse from '../Assets/CLUB HOUSE ELVATION -  (1).jpg';
// import clubhouse2 from '../Assets/CLUB HOUSE ELVATION -  (2).jpg';
// import clubhouse3 from '../Assets/CLUB HOUSE ELVATION -  (3).jpg';

// // RevealImage Component with Silver Shimmer Effect (No Scale)
// const RevealImage = ({ src, alt, className = "" }) => {
//   const wrapperRef = useRef();
//   const [isRevealed, setIsRevealed] = useState(false);

//   useEffect(() => {
//     const el = wrapperRef.current;
//     const observer = new IntersectionObserver(
//       entries => {
//         entries.forEach(entry => {
//           if (entry.isIntersecting) {
//             setIsRevealed(true);
//             observer.unobserve(el);
//           }
//         });
//       },
//       { threshold: 0.3 }
//     );
//     if (el) observer.observe(el);
//     return () => {
//       if (el) observer.unobserve(el);
//     };
//   }, []);
  
//   return (
//     <div ref={wrapperRef} className={`relative overflow-hidden ${className}`}>
//       <img 
//         src={src} 
//         alt={alt} 
//         className={`w-full h-full object-cover relative z-[1] transition-all duration-[1500ms] ease-out ${
//           isRevealed ? 'opacity-100' : 'opacity-0'
//         }`}
//         style={{ transitionDelay: '800ms' }}
//       />
      
//       {/* PURE SILVER Gradient Mask */}
//       <div 
//         className={`absolute top-0 left-0 w-full h-full z-[2] transition-transform duration-[1500ms] ${
//           isRevealed ? 'scale-x-0 origin-right' : 'scale-x-100 origin-left'
//         }`}
//         style={{ 
//           transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)',
//           background: 'linear-gradient(90deg, #C0C0C0 0%, #E8E8E8 25%, #FFFFFF 50%, #E8E8E8 75%, #C0C0C0 100%)'
//         }}
//       />
      
//       {/* Silver Shimmer */}
//       <div 
//         className={`absolute top-0 left-0 w-full h-full z-[3] transition-all duration-[1500ms] ${
//           isRevealed ? 'opacity-0 translate-x-full' : 'opacity-100 translate-x-0'
//         }`}
//         style={{ 
//           transitionDelay: '300ms',
//           background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.8) 50%, transparent 100%)',
//           transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)'
//         }}
//       />
//     </div>
//   );
// };

// // RevealContent Component for Text/Content
// const RevealContent = ({ children, className = "", delay = 0 }) => {
//   const contentRef = useRef();
//   const [isRevealed, setIsRevealed] = useState(false);

//   useEffect(() => {
//     const el = contentRef.current;
//     const observer = new IntersectionObserver(
//       entries => {
//         entries.forEach(entry => {
//           if (entry.isIntersecting) {
//             setTimeout(() => {
//               setIsRevealed(true);
//             }, delay);
//             observer.unobserve(el);
//           }
//         });
//       },
//       { threshold: 0.1 }
//     );
//     if (el) observer.observe(el);
//     return () => {
//       if (el) observer.unobserve(el);
//     };
//   }, [delay]);
  
//   return (
//     <div 
//       ref={contentRef} 
//       className={`transition-all duration-1000 ${
//         isRevealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[60px]'
//       } ${className}`}
//       style={{ transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)' }}
//     >
//       {children}
//     </div>
//   );
// };

// const Home = () => {
//   const [currentSlide, setCurrentSlide] = useState(0);

//   const slides = [
//     {
//       image: aerialview,
//       title: "Welcome To NIHIRA REALTORS LLP",
//       subtitle: "Everyone has their own idea of what their favourite place should look and feel like. NIHIRA REALTORS LLP, with its knowledge and expertise, can help you achieve this."
//     },
//     {
//       image: aerialview2,
//       title: "Building Your Vision",
//       subtitle: "With quality craftsmanship and exceptional customer service"
//     },
//     {
//       image: aerialview3,
//       title: "Creating Your Dream Home",
//       subtitle: "A perfect blend of luxury and comfort in every detail"
//     },
//     {
//       image: aerialview4,
//       title: "Bringing Your Construction Visions to Life",
//       subtitle: "19.02 lakhs sqft of completed land construction"
//     }
//   ];

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentSlide((prev) => (prev + 1) % slides.length);
//     }, 5000);
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div className="home">
//       {/* Hero Section - Full Screen Slider */}
//       <section className="relative h-screen overflow-hidden mb-24">
//         {slides.map((slide, index) => (
//           <div
//             key={index}
//             className={`absolute inset-0 transition-opacity duration-1000 ${
//               index === currentSlide ? 'opacity-100' : 'opacity-0'
//             }`}
//           >
            
// <img
//   src={slide.image}
//   alt=""
//   className="absolute inset-0 w-full h-full object-cover"
// />


            
            
//             <div className="absolute inset-0 bg-black/40" />
            
//             {/* Hero Content */}
//             <div className="absolute inset-0 flex items-center justify-center text-center px-4">
//               <div className="max-w-4xl">
//                 <h1 className="font-display text-5xl md:text-7xl font-bold text-white mb-6 tracking-wide">
//                   {slide.title}
//                 </h1>
//                 <p className="text-xl md:text-2xl text-white/90 font-light leading-relaxed">
//                   {slide.subtitle}
//                 </p>
//               </div>
//             </div>
//           </div>
//         ))}

//         {/* Slide Navigation Arrows */}
//         <button
//           onClick={() => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)}
//           className="absolute left-8 top-1/2 -translate-y-1/2 z-10 w-14 h-14 flex items-center justify-center bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-all border border-white/30"
//         >
//           <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
//           </svg>
//         </button>
//         <button
//           onClick={() => setCurrentSlide((prev) => (prev + 1) % slides.length)}
//           className="absolute right-8 top-1/2 -translate-y-1/2 z-10 w-14 h-14 flex items-center justify-center bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-all border border-white/30"
//         >
//           <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//           </svg>
//         </button>

//         {/* Slide Indicators */}
//         <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-3 z-10">
//           {slides.map((_, index) => (
//             <button
//               key={index}
//               onClick={() => setCurrentSlide(index)}
//               className={`w-3 h-3 rounded-full transition-all ${
//                 index === currentSlide ? 'bg-white w-8' : 'bg-white/50'
//               }`}
//             />
//           ))}
//         </div>
//       </section>

//       {/* Welcome Home Section */}
//       <section className="min-h-screen bg-luxury-bg flex items-center mb-24">
//         <div className="w-full grid lg:grid-cols-2">
//           {/* Left Side - Content */}
//           <div className="flex items-center justify-center px-8 lg:px-16 py-20">
//             <div className="max-w-xl">
//               <RevealContent delay={0}>
//                 <h2 className="font-display text-5xl md:text-6xl font-normal text-[#8B4513] mb-8 italic">
//                   Welcome Home
//                 </h2>
//               </RevealContent>
              
//               <RevealContent delay={200}>
//                 <div className="space-y-4 text-luxury-dark text-base leading-relaxed">
//                   <p>
//                     For us, home is not a place, but a feeling. While you stay at Nihira Luxury Properties, 
//                     we hope you feel rested, content and heartfelt joy.
//                   </p>
//                   <p>
//                     The word Nihira has its roots in excellence which translates to 'Premium Quality'. 
//                     We hope we can share this experience of luxury and respect with you, and that it adds 
//                     meaning to your stay with us. This is the core spirit of Nihira Realtors, and a culture 
//                     we wish for you to remember fondly.
//                   </p>
//                   <p>
//                     Our home is now yours to stay, we hope you enjoy it.
//                   </p>
//                 </div>
//               </RevealContent>
              
//               <RevealContent delay={400}>
//                 <div className="mt-8">
//                   <p className="font-display text-3xl text-[#8B4513] italic">
//                     Host Yourself Family
//                   </p>
//                 </div>
//               </RevealContent>
//             </div>
//           </div>

//           {/* Right Side - Image */}
//           <div className="relative h-[400px] md:h-[520px] lg:h-[620px] overflow-hidden">

//             <RevealImage
//               src={aerialview}
//               alt="Luxury Interior"
//               className="absolute inset-0 w-full h-full"
//             />
//           </div>
//         </div>
//       </section>

//       {/* About Section - Split Layout */}
//       <section className="min-h-screen bg-white flex items-center mb-24">
//         <div className="w-full grid lg:grid-cols-2">
//           {/* Left Side - Content */}
//           <div className="flex items-center justify-center px-8 lg:px-16 py-20">
//             <div className="max-w-xl">
//               <RevealContent delay={0}>
//                 <div className="mb-8">
//                   <span className="text-sm tracking-[0.3em] text-gray-500 uppercase">About Us</span>
//                 </div>
//               </RevealContent>
              
//               <RevealContent delay={100}>
//                 <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 mb-8">
//                   Building Dreams, Creating Homes
//                 </h2>
//               </RevealContent>
              
//               <RevealContent delay={200}>
//                 <div className="space-y-6 text-gray-600 text-lg leading-relaxed">
//                   <p>
//                     At NIHIRA REALTORS LLP, we understand that people everywhere are searching for 
//                     a home to call their own. We want to make this search as joyful as finally finding 
//                     the perfect home because we understand that finding a home is much more than an 
//                     online search.
//                   </p>
//                   <p>
//                     In the last many years, we have completed <span className="font-semibold text-gray-900">19.02 lakhs sqft</span> of 
//                     land construction. In addition to ownership residential flat constructions, we have 
//                     successfully completed industrial, commercial, and special structure projects as well.
//                   </p>
//                 </div>
//               </RevealContent>

//               {/* Features Grid */}
//               <RevealContent delay={400}>
//                 <div className="mt-12 grid grid-cols-3 gap-8">
//                   <div className="text-center">
//                     <div className="text-3xl font-bold text-[#8B4513] mb-2">10+</div>
//                     <div className="text-sm text-gray-600">Years Experience</div>
//                   </div>
//                   <div className="text-center">
//                     <div className="text-3xl font-bold text-[#8B4513] mb-2">100%</div>
//                     <div className="text-sm text-gray-600">Quality Work</div>
//                   </div>
//                   <div className="text-center">
//                     <div className="text-3xl font-bold text-[#8B4513] mb-2">Fast</div>
//                     <div className="text-sm text-gray-600">Execution</div>
//                   </div>
//                 </div>
//               </RevealContent>
//             </div>
//           </div>

//           {/* Right Side - Image */}
//           <div className="relative h-[450px] md:h-[550px] lg:h-[720px] overflow-hidden">

//             <RevealImage
//               src={clubhouse}
//               alt="Luxury Interior"
//               className="absolute inset-0 w-full h-full"
//             />
//             <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent z-10" />
//           </div>
//         </div>
//       </section>

//       {/* Why Choose Us Section */}
//       <section className="py-24 bg-[#F5F1ED] mb-24">
//         <div className="max-w-7xl mx-auto px-8">
//           <RevealContent>
//             <div className="text-center mb-16">
//               <span className="text-sm tracking-[0.3em] text-gray-500 uppercase">Why Choose Us</span>
//               <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 mt-4">
//                 Excellence in Every Detail
//               </h2>
//             </div>
//           </RevealContent>

//           <div className="grid md:grid-cols-3 gap-12">
//             {/* Feature 1 */}
//             <RevealContent delay={0}>
//               <div className="text-center">
//                 <div className="w-20 h-20 mx-auto mb-6 bg-[#8B4513] rounded-full flex items-center justify-center">
//                   <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
//                   </svg>
//                 </div>
//                 <h3 className="text-2xl font-semibold text-gray-900 mb-4">Experience</h3>
//                 <p className="text-gray-600 leading-relaxed">
//                   Our team has a combined 10 years of experience in the construction industry. 
//                   We have completed numerous successful projects for satisfied clients.
//                 </p>
//               </div>
//             </RevealContent>

//             {/* Feature 2 */}
//             <RevealContent delay={200}>
//               <div className="text-center">
//                 <div className="w-20 h-20 mx-auto mb-6 bg-[#8B4513] rounded-full flex items-center justify-center">
//                   <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
//                   </svg>
//                 </div>
//                 <h3 className="text-2xl font-semibold text-gray-900 mb-4">Quality Workmanship</h3>
//                 <p className="text-gray-600 leading-relaxed">
//                   We are committed to delivering high-quality workmanship on every project using only 
//                   the best materials and skilled craftsmen.
//                 </p>
//               </div>
//             </RevealContent>

//             {/* Feature 3 */}
//             <RevealContent delay={400}>
//               <div className="text-center">
//                 <div className="w-20 h-20 mx-auto mb-6 bg-[#8B4513] rounded-full flex items-center justify-center">
//                   <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
//                   </svg>
//                 </div>
//                 <h3 className="text-2xl font-semibold text-gray-900 mb-4">Fast Execution</h3>
//                 <p className="text-gray-600 leading-relaxed">
//                   We recognize we are a partner with our customers to provide high quality design 
//                   and services at a fair price with timely delivery.
//                 </p>
//               </div>
//             </RevealContent>
//           </div>
//         </div>
//       </section>

//       {/* Featured Projects Section - 2 Properties */}
//       <section className="py-24 bg-white mb-24">
//         <div className="max-w-7xl mx-auto px-8">
//           <RevealContent>
//             <div className="text-center mb-16">
//               <span className="text-sm tracking-[0.3em] text-gray-500 uppercase">Our Projects</span>
//               <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 mt-4 mb-6">
//                 Featured Properties
//               </h2>
//               <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//                 Discover our exclusive developments designed to bring your dream home to reality
//               </p>
//             </div>
//           </RevealContent>

//           <div className="grid lg:grid-cols-2 gap-12">
//             {/* The Crown Villas */}
//             <div className="group cursor-pointer">
//               <div className="relative overflow-hidden mb-6 h-[500px] bg-gray-900">
//                 <RevealImage
//                   src={clubhouse2}
//                   alt="The Crown Villas"
//                   className="w-full h-full"
//                 />
//                 <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-90 group-hover:opacity-100 transition-opacity duration-500 z-10" />
                
//                 {/* Floating Tag */}
//                 <div className="absolute top-6 right-6 bg-white px-4 py-2 shadow-lg z-20">
//                   <span className="text-sm font-semibold text-gray-900">8.7 Acres</span>
//                 </div>

//                 {/* Bottom Content Overlay */}
//                 <div className="absolute bottom-0 left-0 right-0 p-8 text-white transform transition-transform duration-500 group-hover:translate-y-0 z-20">
//                   <div className="flex items-center gap-2 mb-3 text-sm">
//                     <MapPin className="w-4 h-4" />
//                     <span>Rameshwar Banda Village, Patancheru</span>
//                   </div>
//                   <h3 className="text-3xl font-bold mb-2">The Crown Villas</h3>
//                   <div className="flex items-center gap-2 text-sm mb-4">
//                     <HomeIcon className="w-4 h-4" />
//                     <span>125 Exclusive Villas</span>
//                   </div>
//                 </div>
//               </div>

//               {/* Description Card */}
//               <RevealContent delay={200}>
//                 <div className="bg-[#F5F1ED] p-8 transform transition-all duration-500 group-hover:shadow-xl">
//                   <p className="text-gray-700 leading-relaxed mb-6">
//                     The Crown Villas project is an 8.7 acre development of 125 exclusive Villas, 
//                     set in Rameshwar Banda Village, Patancheru Mandal, Sangareddy District. 
//                     A calm and quiet locale 6 km from Patancheru, and 30 km from Sangareddy.
//                   </p>
//                   <Link 
//                     to="/projects/crown-villas"
//                     className="inline-flex items-center gap-2 text-[#8B4513] font-semibold hover:gap-4 transition-all group"
//                   >
//                     EXPLORE PROJECT 
//                     <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
//                   </Link>
//                 </div>
//               </RevealContent>
//             </div>

//             {/* Royal Oak Estates */}
//             <div className="group cursor-pointer">
//               <div className="relative overflow-hidden mb-6 h-[500px] bg-gray-900">
//                 <RevealImage
//                   src={clubhouse3}
//                   alt="Royal Oak Estates"
//                   className="w-full h-full"
//                 />
//                 <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-90 group-hover:opacity-100 transition-opacity duration-500 z-10" />
                
//                 {/* Floating Tag */}
//                 <div className="absolute top-6 right-6 bg-white px-4 py-2 shadow-lg z-20">
//                   <span className="text-sm font-semibold text-gray-900">15 Acres</span>
//                 </div>

//                 {/* Bottom Content Overlay */}
//                 <div className="absolute bottom-0 left-0 right-0 p-8 text-white transform transition-transform duration-500 group-hover:translate-y-0 z-20">
//                   <div className="flex items-center gap-2 mb-3 text-sm">
//                     <MapPin className="w-4 h-4" />
//                     <span>Zaheerabad, Bidar Road @ NIMZ</span>
//                   </div>
//                   <h3 className="text-3xl font-bold mb-2">Royal Oak Estates</h3>
//                   <div className="flex items-center gap-2 text-sm mb-4">
//                     <HomeIcon className="w-4 h-4" />
//                     <span>Premium Plots Available</span>
//                   </div>
//                 </div>
//               </div>

//               {/* Description Card */}
//               <RevealContent delay={200}>
//                 <div className="bg-[#F5F1ED] p-8 transform transition-all duration-500 group-hover:shadow-xl">
//                   <p className="text-gray-700 leading-relaxed mb-6">
//                     Royal Oak is a 15 acre development located in Zaheerabad, on the Bidar Road, 
//                     just 3 km from the National Investment Manufacturing Zone (NIMZ). 
//                     Phase 1 of this prestigious project is now open for bookings.
//                   </p>
//                   <Link 
//                     to="/projects/royal-oak-estates"
//                     className="inline-flex items-center gap-2 text-[#8B4513] font-semibold hover:gap-4 transition-all group"
//                   >
//                     EXPLORE PROJECT 
//                     <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
//                   </Link>
//                 </div>
//               </RevealContent>
//             </div>
//           </div>

//           {/* View All Projects Button */}
//           <RevealContent delay={400}>
//             <div className="text-center mt-16">
//               <Link 
//                 to="/projects"
//                 className="inline-block px-12 py-4 bg-[#8B4513] text-white font-semibold hover:bg-[#6d3410] transition-colors shadow-lg hover:shadow-xl"
//               >
//                 VIEW ALL PROJECTS
//               </Link>
//             </div>
//           </RevealContent>
//         </div>
//       </section>

//       {/* Nihira Realtors Brand Section */}
//       <section className="min-h-screen flex items-center mb-24">
//         <div className="w-full grid lg:grid-cols-2">
//           {/* Left Side – Image with Decorative Frame */}
//           <div className="relative min-h-[600px] lg:min-h-screen bg-black flex items-center justify-center p-12 overflow-hidden">
//             <div className="relative max-w-md">
//               {/* Decorative Frame */}
//               <div
//                 className="absolute inset-0 border-8 border-[#C4A57B] z-10"
//                 style={{ transform: "translate(-20px, -20px)" }}
//               />

//               <RevealImage
//                 src="https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&q=80"
//                 alt="Nihira Realtors – Premium Living Spaces"
//                 className="relative z-20 w-full"
//               />

//               {/* Brand Name */}
//               <RevealContent delay={800}>
//                 <div className="absolute bottom-0 left-0 right-0 text-center -mb-8 z-30">
//                   <p className="font-display text-4xl text-[#C4A57B] italic">
//                     Nihira Realtors
//                   </p>
//                 </div>
//               </RevealContent>
//             </div>
//           </div>

//           {/* Right Side – Olive Green Background with Content */}
//           <div
//             className="relative min-h-[600px] lg:min-h-screen flex items-center"
//             style={{ backgroundColor: "#8B9B7E" }}
//           >
//             <div className="px-8 lg:px-20 py-20 text-white max-w-xl">
//               <RevealContent delay={0}>
//                 <h3 className="text-3xl mb-8 font-light">
//                   Welcome to Nihira Realtors
//                 </h3>
//               </RevealContent>

//               <RevealContent delay={200}>
//                 <div className="space-y-6 text-base leading-relaxed">
//                   <p>
//                     Discover thoughtfully designed spaces where modern living meets
//                     long-term value.
//                   </p>
//                   <p>
//                     Nihira Realtors develops premium residential and commercial
//                     properties with a focus on quality construction, strategic
//                     locations, and sustainable growth.
//                   </p>
//                   <p>
//                     Every project reflects our commitment to trust, transparency,
//                     and delivering spaces that elevate lifestyles.
//                   </p>
//                   <p className="font-semibold">
//                     Your journey to the perfect property begins here.
//                   </p>
//                 </div>
//               </RevealContent>

//               {/* CTA */}
//               <RevealContent delay={400}>
//                 <div className="mt-12">
//                   <Link
//                     to="/projects"
//                     className="inline-flex items-center gap-2 text-white text-lg font-semibold hover:gap-4 transition-all"
//                   >
//                     VIEW PROJECTS <ArrowRight className="w-5 h-5" />
//                   </Link>
//                   <p className="mt-4 text-base">
//                     Residential & Commercial Developments
//                   </p>
//                 </div>
//               </RevealContent>
//             </div>

//             {/* Small Image in Corner */}
//             {/* <div className="absolute bottom-12 right-12 w-64 h-64 border-8 border-[#C4A57B] hidden lg:block overflow-hidden">
//               <RevealImage
//                 src="https://images.unsplash.com/photo-1609709295948-17d77cb2a69b?w=400&q=80"
//                 alt="Nihira Realtors Project Preview"
//                 className="w-full h-full"
//               />
//             </div> */}

//             {/* Vertical Branding */}
//             <div className="absolute right-0 top-1/2 -translate-y-1/2 hidden lg:block">
//               <p
//                 className="font-display text-6xl text-[#C4A57B]/30 italic"
//                 style={{
//                   writingMode: "vertical-rl",
//                   textOrientation: "mixed",
//                 }}
//               >
//                 Nihira Realtors
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Call to Action Section */}
//       <section className="relative py-32 mb-24 overflow-hidden">
//         <div className="absolute inset-0">
//           <img
//             src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920&q=80"
//             alt="CTA Background"
//             className="w-full h-full object-cover"
//           />
//           <div className="absolute inset-0 bg-black/60" />
//         </div>
        
//         <div className="relative max-w-4xl mx-auto px-8 text-center text-white">
//           <RevealContent delay={0}>
//             <h2 className="font-display text-4xl md:text-6xl font-bold mb-6">
//               Let's Make Your Dream Home a Reality
//             </h2>
//           </RevealContent>
          
//           <RevealContent delay={200}>
//             <p className="text-xl md:text-2xl mb-12 text-white/90">
//               Connect with us today to discuss your vision and explore our exclusive properties
//             </p>
//           </RevealContent>
          
//           <RevealContent delay={400}>
//             <div className="flex flex-col sm:flex-row gap-6 justify-center">
//               <Link 
//                 to="/contact"
//                 className="inline-block px-10 py-4 bg-white text-gray-900 font-semibold hover:bg-gray-100 transition-colors shadow-xl"
//               >
//                 SCHEDULE A VISIT
//               </Link>
//               <Link 
//                 to="/projects"
//                 className="inline-block px-10 py-4 border-2 border-white text-white font-semibold hover:bg-white hover:text-gray-900 transition-all"
//               >
//                 VIEW PROJECTS
//               </Link>
//             </div>
//           </RevealContent>
//         </div>
//       </section>

//       {/* Bottom Contact Section */}
//       <section className="bg-gray-900 py-12">
//         <div className="max-w-7xl mx-auto px-8">
//           <RevealContent>
//             <div className="grid md:grid-cols-3 gap-8 text-white">
//               <div>
//                 <h4 className="text-lg font-semibold mb-3">Address</h4>
//                 <p className="text-gray-400">6-50/6/101, Chandanagar</p>
//               </div>
//               <div>
//                 <h4 className="text-lg font-semibold mb-3">Email</h4>
//                 <a href="mailto:preetham.miriyala@gmail.com" className="text-gray-400 hover:text-white transition-colors">
//                   preetham.miriyala@gmail.com
//                 </a>
//               </div>
//               <div>
//                 <h4 className="text-lg font-semibold mb-3">Phone</h4>
//                 <a href="tel:+919584646464" className="text-gray-400 hover:text-white transition-colors">
//                   +91 9584646464
//                 </a>
//               </div>
//             </div>
//           </RevealContent>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Home;


import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin, Home as HomeIcon } from 'lucide-react';
import aerialview from '../Assets/AERIAL VIEW -  (1).jpg';
import aerialview2 from '../Assets/AERIAL VIEW -  (2).jpg';
import aerialview3 from '../Assets/AERIAL VIEW -  (5).jpg';
import aerialview4 from '../Assets/AERIAL VIEW -  (6).jpg';
import clubhouse from '../Assets/CLUB HOUSE ELVATION -  (1).jpg';
import clubhouse2 from '../Assets/CLUB HOUSE ELVATION -  (2).jpg';
import clubhouse3 from '../Assets/CLUB HOUSE ELVATION -  (3).jpg';
import clubhouse5 from '../Assets/2.png';

// RevealImage Component with Silver Shimmer Effect (No Scale)
const RevealImage = ({ src, alt, className = "" }) => {
  const wrapperRef = useRef();
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const el = wrapperRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsRevealed(true);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.3 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);
  
  return (
    <div ref={wrapperRef} className={`relative overflow-hidden ${className}`}>
      <img 
        src={src} 
        alt={alt} 
        className={`w-full h-full object-cover relative z-[1] transition-all duration-[1500ms] ease-out ${
          isRevealed ? 'opacity-100' : 'opacity-0'
        }`}
        style={{ transitionDelay: '800ms' }}
      />
      
      {/* PURE SILVER Gradient Mask */}
      <div 
        className={`absolute top-0 left-0 w-full h-full z-[2] transition-transform duration-[1500ms] ${
          isRevealed ? 'scale-x-0 origin-right' : 'scale-x-100 origin-left'
        }`}
        style={{ 
          transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)',
          background: 'linear-gradient(90deg, #C0C0C0 0%, #E8E8E8 25%, #FFFFFF 50%, #E8E8E8 75%, #C0C0C0 100%)'
        }}
      />
      
      {/* Silver Shimmer */}
      <div 
        className={`absolute top-0 left-0 w-full h-full z-[3] transition-all duration-[1500ms] ${
          isRevealed ? 'opacity-0 translate-x-full' : 'opacity-100 translate-x-0'
        }`}
        style={{ 
          transitionDelay: '300ms',
          background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.8) 50%, transparent 100%)',
          transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)'
        }}
      />
    </div>
  );
};

// RevealContent Component for Text/Content
const RevealContent = ({ children, className = "", delay = 0 }) => {
  const contentRef = useRef();
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const el = contentRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              setIsRevealed(true);
            }, delay);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.1 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, [delay]);
  
  return (
    <div 
      ref={contentRef} 
      className={`transition-all duration-1000 ${
        isRevealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[60px]'
      } ${className}`}
      style={{ transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)' }}
    >
      {children}
    </div>
  );
};

// ── APPROVAL BADGE BANNER ──────────────────────────────────────────────────────
const ApprovalBanner = () => (
  <div
    style={{
      background: 'linear-gradient(90deg, #1a1208 0%, #2c1f0a 40%, #1a1208 100%)',
      borderBottom: '1px solid rgba(196,165,123,0.35)',
    }}
    className="w-full py-0"
  >
    {/* thin gold rule top */}
    <div style={{ height: 2, background: 'linear-gradient(90deg, transparent, #C4A57B 30%, #e8d5a3 50%, #C4A57B 70%, transparent)' }} />

    <div className="max-w-7xl mx-auto px-6 py-3 flex flex-wrap items-center justify-center gap-0 md:gap-0">

      {/* Left label */}
      <div className="flex items-center gap-3 pr-6 mr-6" style={{ borderRight: '1px solid rgba(196,165,123,0.3)' }}>
        {/* Shield icon */}
        <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11 1L2 5V13C2 18.55 5.84 23.74 11 25C16.16 23.74 20 18.55 20 13V5L11 1Z"
            fill="none" stroke="#C4A57B" strokeWidth="1.5" strokeLinejoin="round"/>
          <path d="M7.5 13l2.5 2.5 5-5" stroke="#C4A57B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <span
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            color: '#C4A57B',
            fontSize: '0.7rem',
            letterSpacing: '0.22em',
            textTransform: 'uppercase',
            fontWeight: 600,
          }}
        >
          Government Approved
        </span>
      </div>

      {/* RERA badge */}
      <div className="flex items-center gap-4 px-6 py-1 mx-2" style={{ borderRight: '1px solid rgba(196,165,123,0.2)' }}>
        <div
          style={{
            width: 36, height: 36, borderRadius: '50%',
            background: 'radial-gradient(circle, #3a2a0a 0%, #1a1208 100%)',
            border: '1.5px solid #C4A57B',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <span style={{ color: '#C4A57B', fontSize: '0.55rem', fontWeight: 700, letterSpacing: '0.05em' }}>RERA</span>
        </div>
        <div>
          <p style={{ color: 'rgba(196,165,123,0.6)', fontSize: '0.6rem', letterSpacing: '0.18em', textTransform: 'uppercase', marginBottom: 1, fontFamily: "'Jost', sans-serif" }}>
            RERA Approved
          </p>
          <p style={{ color: '#e8d5a3', fontSize: '0.78rem', fontFamily: "'Jost', sans-serif", fontWeight: 500, letterSpacing: '0.04em' }}>
            P01100007199
          </p>
        </div>
      </div>

      {/* Divider dot */}
      <div
        style={{ width: 4, height: 4, borderRadius: '50%', background: '#C4A57B', opacity: 0.4, margin: '0 8px' }}
        className="hidden md:block"
      />

      {/* HMDA badge */}
      <div className="flex items-center gap-4 px-6 py-1 mx-2">
        <div
          style={{
            width: 36, height: 36, borderRadius: '50%',
            background: 'radial-gradient(circle, #3a2a0a 0%, #1a1208 100%)',
            border: '1.5px solid #C4A57B',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <span style={{ color: '#C4A57B', fontSize: '0.5rem', fontWeight: 700, letterSpacing: '0.05em', textAlign: 'center', lineHeight: 1.1 }}>HMDA</span>
        </div>
        <div>
          <p style={{ color: 'rgba(196,165,123,0.6)', fontSize: '0.6rem', letterSpacing: '0.18em', textTransform: 'uppercase', marginBottom: 1, fontFamily: "'Jost', sans-serif" }}>
            HMDA Approved
          </p>
          <p style={{ color: '#e8d5a3', fontSize: '0.78rem', fontFamily: "'Jost', sans-serif", fontWeight: 500, letterSpacing: '0.04em' }}>
            000145/LO/Plg/HMDA/2023
          </p>
        </div>
      </div>

    </div>

    {/* thin gold rule bottom */}
    <div style={{ height: 2, background: 'linear-gradient(90deg, transparent, #C4A57B 30%, #e8d5a3 50%, #C4A57B 70%, transparent)' }} />
  </div>
);
// ──────────────────────────────────────────────────────────────────────────────

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: aerialview,
      title: "Welcome To NIHIRA REALTORS LLP",
      subtitle: "Everyone has their own idea of what their favourite place should look and feel like. NIHIRA REALTORS LLP, with its knowledge and expertise, can help you achieve this."
    },
    {
      image: aerialview2,
      title: "Building Your Vision",
      subtitle: "With quality craftsmanship and exceptional customer service"
    },
    {
      image: aerialview3,
      title: "Creating Your Dream Home",
      subtitle: "A perfect blend of luxury and comfort in every detail"
    },
    {
      image: aerialview4,
      title: "Bringing Your Construction Visions to Life",
      subtitle: "19.02 lakhs sqft of completed land construction"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="home">

      {/* ── APPROVAL BANNER ── */}
      <ApprovalBanner />

      {/* Hero Section - Full Screen Slider */}
      <section className="relative h-screen overflow-hidden mb-24">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={slide.image}
              alt=""
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/40" />
            
            {/* Hero Content */}
            <div className="absolute inset-0 flex items-center justify-center text-center px-4">
              <div className="max-w-4xl">
                <h1 className="font-display text-5xl md:text-7xl font-bold text-white mb-6 tracking-wide">
                  {slide.title}
                </h1>
                <p className="text-xl md:text-2xl text-white/90 font-light leading-relaxed">
                  {slide.subtitle}
                </p>
              </div>
            </div>
          </div>
        ))}

        {/* Slide Navigation Arrows */}
        <button
          onClick={() => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)}
          className="absolute left-8 top-1/2 -translate-y-1/2 z-10 w-14 h-14 flex items-center justify-center bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-all border border-white/30"
        >
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button
          onClick={() => setCurrentSlide((prev) => (prev + 1) % slides.length)}
          className="absolute right-8 top-1/2 -translate-y-1/2 z-10 w-14 h-14 flex items-center justify-center bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-all border border-white/30"
        >
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>

        {/* Slide Indicators */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-3 z-10">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-all ${
                index === currentSlide ? 'bg-white w-8' : 'bg-white/50'
              }`}
            />
          ))}
        </div>
      </section>

      {/* Welcome Home Section */}
      <section className="min-h-screen bg-luxury-bg flex items-center mb-24">
        <div className="w-full grid lg:grid-cols-2">
          {/* Left Side - Content */}
          <div className="flex items-center justify-center px-8 lg:px-16 py-20">
            <div className="max-w-xl">
              <RevealContent delay={0}>
                <h2 className="font-display text-5xl md:text-6xl font-normal text-[#8B4513] mb-8 italic">
                  Welcome Home
                </h2>
              </RevealContent>
              
              <RevealContent delay={200}>
                <div className="space-y-4 text-luxury-dark text-base leading-relaxed">
                  <p>
                    For us, home is not a place, but a feeling. While you stay at Nihira Luxury Properties, 
                    we hope you feel rested, content and heartfelt joy.
                  </p>
                  <p>
                    The word Nihira has its roots in excellence which translates to 'Premium Quality'. 
                    We hope we can share this experience of luxury and respect with you, and that it adds 
                    meaning to your stay with us. This is the core spirit of Nihira Realtors, and a culture 
                    we wish for you to remember fondly.
                  </p>
                  <p>
                    Our home is now yours to stay, we hope you enjoy it.
                  </p>
                </div>
              </RevealContent>
              
              <RevealContent delay={400}>
                <div className="mt-8">
                  <p className="font-display text-3xl text-[#8B4513] italic">
                    Host Yourself Family
                  </p>
                </div>
              </RevealContent>
            </div>
          </div>

          {/* Right Side - Image */}
          <div className="relative h-[400px] md:h-[520px] lg:h-[620px] overflow-hidden">
            <RevealImage
              src={aerialview}
              alt="Luxury Interior"
              className="absolute inset-0 w-full h-full"
            />
          </div>
        </div>
      </section>

      {/* About Section - Split Layout */}
      <section className="min-h-screen bg-white flex items-center mb-24">
        <div className="w-full grid lg:grid-cols-2">
          {/* Left Side - Content */}
          <div className="flex items-center justify-center px-8 lg:px-16 py-20">
            <div className="max-w-xl">
              <RevealContent delay={0}>
                <div className="mb-8">
                  <span className="text-sm tracking-[0.3em] text-gray-500 uppercase">About Us</span>
                </div>
              </RevealContent>
              
              <RevealContent delay={100}>
                <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 mb-8">
                  Building Dreams, Creating Homes
                </h2>
              </RevealContent>
              
              <RevealContent delay={200}>
                <div className="space-y-6 text-gray-600 text-lg leading-relaxed">
                  <p>
                    At NIHIRA REALTORS LLP, we understand that people everywhere are searching for 
                    a home to call their own. We want to make this search as joyful as finally finding 
                    the perfect home because we understand that finding a home is much more than an 
                    online search.
                  </p>
                  <p>
                    In the last many years, we have completed <span className="font-semibold text-gray-900">19.02 lakhs sqft</span> of 
                    land construction. In addition to ownership residential flat constructions, we have 
                    successfully completed industrial, commercial, and special structure projects as well.
                  </p>
                </div>
              </RevealContent>

              {/* Features Grid */}
              <RevealContent delay={400}>
                <div className="mt-12 grid grid-cols-3 gap-8">
                  <div className="text-center">
                    <div className="text-3xl font-bold text-[#8B4513] mb-2">10+</div>
                    <div className="text-sm text-gray-600">Years Experience</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-[#8B4513] mb-2">100%</div>
                    <div className="text-sm text-gray-600">Quality Work</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-[#8B4513] mb-2">Fast</div>
                    <div className="text-sm text-gray-600">Execution</div>
                  </div>
                </div>
              </RevealContent>
            </div>
          </div>

          {/* Right Side - Image */}
          <div className="relative h-[450px] md:h-[550px] lg:h-[720px] overflow-hidden">
            <RevealImage
              src={clubhouse}
              alt="Luxury Interior"
              className="absolute inset-0 w-full h-full"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent z-10" />
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-24 bg-[#F5F1ED] mb-24">
        <div className="max-w-7xl mx-auto px-8">
          <RevealContent>
            <div className="text-center mb-16">
              <span className="text-sm tracking-[0.3em] text-gray-500 uppercase">Why Choose Us</span>
              <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 mt-4">
                Excellence in Every Detail
              </h2>
            </div>
          </RevealContent>

          <div className="grid md:grid-cols-3 gap-12">
            {/* Feature 1 */}
            <RevealContent delay={0}>
              <div className="text-center">
                <div className="w-20 h-20 mx-auto mb-6 bg-[#8B4513] rounded-full flex items-center justify-center">
                  <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Experience</h3>
                <p className="text-gray-600 leading-relaxed">
                  Our team has a combined 10 years of experience in the construction industry. 
                  We have completed numerous successful projects for satisfied clients.
                </p>
              </div>
            </RevealContent>

            {/* Feature 2 */}
            <RevealContent delay={200}>
              <div className="text-center">
                <div className="w-20 h-20 mx-auto mb-6 bg-[#8B4513] rounded-full flex items-center justify-center">
                  <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Quality Workmanship</h3>
                <p className="text-gray-600 leading-relaxed">
                  We are committed to delivering high-quality workmanship on every project using only 
                  the best materials and skilled craftsmen.
                </p>
              </div>
            </RevealContent>

            {/* Feature 3 */}
            <RevealContent delay={400}>
              <div className="text-center">
                <div className="w-20 h-20 mx-auto mb-6 bg-[#8B4513] rounded-full flex items-center justify-center">
                  <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Fast Execution</h3>
                <p className="text-gray-600 leading-relaxed">
                  We recognize we are a partner with our customers to provide high quality design 
                  and services at a fair price with timely delivery.
                </p>
              </div>
            </RevealContent>
          </div>
        </div>
      </section>

      {/* Featured Projects Section - 2 Properties */}
      <section className="py-24 bg-white mb-24">
        <div className="max-w-7xl mx-auto px-8">
          <RevealContent>
            <div className="text-center mb-16">
              <span className="text-sm tracking-[0.3em] text-gray-500 uppercase">Our Projects</span>
              <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 mt-4 mb-6">
                Featured Properties
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Discover our exclusive developments designed to bring your dream home to reality
              </p>
            </div>
          </RevealContent>

          <div className="grid lg:grid-cols-2 gap-12">
            {/* The Crown Villas */}
            <div className="group cursor-pointer">
              <div className="relative overflow-hidden mb-6 h-[500px] bg-gray-900">
                <RevealImage
                  src={clubhouse5}
                  alt="The Crown Villas"
                  className="w-full h-full"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-90 group-hover:opacity-100 transition-opacity duration-500 z-10" />
                
                {/* Floating Tag */}
                <div className="absolute top-6 right-6 bg-white px-4 py-2 shadow-lg z-20">
                  <span className="text-sm font-semibold text-gray-900">8.7 Acres</span>
                </div>

                {/* Bottom Content Overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-8 text-white transform transition-transform duration-500 group-hover:translate-y-0 z-20">
                  <div className="flex items-center gap-2 mb-3 text-sm">
                    <MapPin className="w-4 h-4" />
                    <span>Rameshwar Banda Village, Patancheru</span>
                  </div>
                  <h3 className="text-3xl font-bold mb-2">The Crown Villas</h3>
                  <div className="flex items-center gap-2 text-sm mb-4">
                    <HomeIcon className="w-4 h-4" />
                    <span>131 Exclusive Villas</span>
                  </div>
                </div>
              </div>

              {/* Description Card */}
              <RevealContent delay={200}>
                <div className="bg-[#F5F1ED] p-8 transform transition-all duration-500 group-hover:shadow-xl">
                  <p className="text-gray-700 leading-relaxed mb-6">
                    The Crown Villas project is an 8.7 acre development of 131 exclusive Villas, 
                    set in Rameshwar Banda Village, Patancheru Mandal, Sangareddy District. 
                    A calm and quiet locale 6 km from Patancheru, and 30 km from Sangareddy.
                  </p>
                  <Link 
                    to="/projects/crown-villas"
                    className="inline-flex items-center gap-2 text-[#8B4513] font-semibold hover:gap-4 transition-all group"
                  >
                    EXPLORE PROJECT 
                    <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
                  </Link>
                </div>
              </RevealContent>
            </div>

            {/* Royal Oak Estates */}
            <div className="group cursor-pointer">
              <div className="relative overflow-hidden mb-6 h-[500px] bg-gray-900">
                <RevealImage
                  src={clubhouse3}
                  alt="Royal Oak Estates"
                  className="w-full h-full"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-90 group-hover:opacity-100 transition-opacity duration-500 z-10" />
                
                {/* Floating Tag */}
                <div className="absolute top-6 right-6 bg-white px-4 py-2 shadow-lg z-20">
                  <span className="text-sm font-semibold text-gray-900">15 Acres</span>
                </div>

                {/* Bottom Content Overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-8 text-white transform transition-transform duration-500 group-hover:translate-y-0 z-20">
                  <div className="flex items-center gap-2 mb-3 text-sm">
                    <MapPin className="w-4 h-4" />
                    <span>Zaheerabad, Bidar Road @ NIMZ</span>
                  </div>
                  <h3 className="text-3xl font-bold mb-2">Royal Oak Estates</h3>
                  <div className="flex items-center gap-2 text-sm mb-4">
                    <HomeIcon className="w-4 h-4" />
                    <span>Premium Plots Available</span>
                  </div>
                </div>
              </div>

              {/* Description Card */}
              <RevealContent delay={200}>
                <div className="bg-[#F5F1ED] p-8 transform transition-all duration-500 group-hover:shadow-xl">
                  <p className="text-gray-700 leading-relaxed mb-6">
                    Royal Oak is a 15 acre development located in Zaheerabad, on the Bidar Road, 
                    just 3 km from the National Investment Manufacturing Zone (NIMZ). 
                    Phase 1 of this prestigious project is now open for bookings.
                  </p>
                  <Link 
                    to="/projects/royal-oak-estates"
                    className="inline-flex items-center gap-2 text-[#8B4513] font-semibold hover:gap-4 transition-all group"
                  >
                    EXPLORE PROJECT 
                    <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
                  </Link>
                </div>
              </RevealContent>
            </div>
          </div>

          {/* View All Projects Button */}
          <RevealContent delay={400}>
            <div className="text-center mt-16">
              <Link 
                to="/projects"
                className="inline-block px-12 py-4 bg-[#8B4513] text-white font-semibold hover:bg-[#6d3410] transition-colors shadow-lg hover:shadow-xl"
              >
                VIEW ALL PROJECTS
              </Link>
            </div>
          </RevealContent>
        </div>
      </section>

      {/* Nihira Realtors Brand Section */}
      <section className="min-h-screen flex items-center mb-24">
        <div className="w-full grid lg:grid-cols-2">
          {/* Left Side – Image with Decorative Frame */}
          <div className="relative min-h-[600px] lg:min-h-screen bg-black flex items-center justify-center p-12 overflow-hidden">
            <div className="relative max-w-md">
              {/* Decorative Frame */}
              <div
                className="absolute inset-0 border-8 border-[#C4A57B] z-10"
                style={{ transform: "translate(-20px, -20px)" }}
              />

              <RevealImage
                src="https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&q=80"
                alt="Nihira Realtors – Premium Living Spaces"
                className="relative z-20 w-full"
              />

              {/* Brand Name */}
              <RevealContent delay={800}>
                <div className="absolute bottom-0 left-0 right-0 text-center -mb-8 z-30">
                  <p className="font-display text-4xl text-[#C4A57B] italic">
                    Nihira Realtors
                  </p>
                </div>
              </RevealContent>
            </div>
          </div>

          {/* Right Side – Olive Green Background with Content */}
          <div
            className="relative min-h-[600px] lg:min-h-screen flex items-center"
            style={{ backgroundColor: "#8B9B7E" }}
          >
            <div className="px-8 lg:px-20 py-20 text-white max-w-xl">
              <RevealContent delay={0}>
                <h3 className="text-3xl mb-8 font-light">
                  Welcome to Nihira Realtors
                </h3>
              </RevealContent>

              <RevealContent delay={200}>
                <div className="space-y-6 text-base leading-relaxed">
                  <p>
                    Discover thoughtfully designed spaces where modern living meets
                    long-term value.
                  </p>
                  <p>
                    Nihira Realtors develops premium residential and commercial
                    properties with a focus on quality construction, strategic
                    locations, and sustainable growth.
                  </p>
                  <p>
                    Every project reflects our commitment to trust, transparency,
                    and delivering spaces that elevate lifestyles.
                  </p>
                  <p className="font-semibold">
                    Your journey to the perfect property begins here.
                  </p>
                </div>
              </RevealContent>

              {/* CTA */}
              <RevealContent delay={400}>
                <div className="mt-12">
                  <Link
                    to="/projects"
                    className="inline-flex items-center gap-2 text-white text-lg font-semibold hover:gap-4 transition-all"
                  >
                    VIEW PROJECTS <ArrowRight className="w-5 h-5" />
                  </Link>
                  <p className="mt-4 text-base">
                    Residential & Commercial Developments
                  </p>
                </div>
              </RevealContent>
            </div>

            {/* Vertical Branding */}
            <div className="absolute right-0 top-1/2 -translate-y-1/2 hidden lg:block">
              <p
                className="font-display text-6xl text-[#C4A57B]/30 italic"
                style={{
                  writingMode: "vertical-rl",
                  textOrientation: "mixed",
                }}
              >
                Nihira Realtors
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="relative py-32 mb-24 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920&q=80"
            alt="CTA Background"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/60" />
        </div>
        
        <div className="relative max-w-4xl mx-auto px-8 text-center text-white">
          <RevealContent delay={0}>
            <h2 className="font-display text-4xl md:text-6xl font-bold mb-6">
              Let's Make Your Dream Home a Reality
            </h2>
          </RevealContent>
          
          <RevealContent delay={200}>
            <p className="text-xl md:text-2xl mb-12 text-white/90">
              Connect with us today to discuss your vision and explore our exclusive properties
            </p>
          </RevealContent>
          
          <RevealContent delay={400}>
            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <Link 
                to="/contact"
                className="inline-block px-10 py-4 bg-white text-gray-900 font-semibold hover:bg-gray-100 transition-colors shadow-xl"
              >
                SCHEDULE A VISIT
              </Link>
              <Link 
                to="/projects"
                className="inline-block px-10 py-4 border-2 border-white text-white font-semibold hover:bg-white hover:text-gray-900 transition-all"
              >
                VIEW PROJECTS
              </Link>
            </div>
          </RevealContent>
        </div>
      </section>

      {/* Bottom Contact Section */}
      <section className="bg-gray-900 py-12">
        <div className="max-w-7xl mx-auto px-8">
          <RevealContent>
            <div className="grid md:grid-cols-3 gap-8 text-white">
              <div>
                <h4 className="text-lg font-semibold mb-3">Address</h4>
                <p className="text-gray-400">6-50/6/101, Chandanagar</p>
              </div>
              <div>
                <h4 className="text-lg font-semibold mb-3">Email</h4>
                <a href="mailto:preetham.miriyala@gmail.com" className="text-gray-400 hover:text-white transition-colors">
                  preetham.miriyala@gmail.com
                </a>
              </div>
              <div>
                <h4 className="text-lg font-semibold mb-3">Phone</h4>
                <a href="tel:+919584646464" className="text-gray-400 hover:text-white transition-colors">
                  +91 9584646464
                </a>
              </div>
            </div>
          </RevealContent>
        </div>
      </section>
    </div>
  );
};

export default Home;